import {ModuleWithProviders, NgModule} from '@angular/core'
import {TfSelectComponent} from './types/tf-select/tf-select.component'
import {TfBooleanComponent} from './types/tf-boolean/tf-boolean.component'
import {TfRangeComponent} from './types/tf-range/tf-range.component'
import {TfIntervalComponent} from './types/tf-interval/tf-interval.component'
import {TfStringComponent} from './types/tf-string/tf-string.component'
import {TfHtmlComponent} from './types/tf-html/tf-html.component'
import {TfSizeComponent} from './types/tf-size/tf-size.component'
import {TfLinkComponent} from './types/tf-link/tf-link.component'
import {TfSmartlistComponent} from './types/tf-smartlist/tf-smartlist.component'
import {AdminSharedModule} from '../../../../compob2b-admin/src/app/admin-shared/admin-shared.module'
import {
  NbAccordionModule,
  NbButtonModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbSpinnerModule,
  NbTooltipModule
} from '@nebular/theme'
import {RouterLink} from '@angular/router'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {AsyncPipe, DatePipe, NgClass, NgForOf, NgIf, SlicePipe} from '@angular/common'
import {TuiEditor} from '@taiga-ui/editor'
import {NgMultiLabelTemplateDirective, NgSelectComponent} from '@ng-select/ng-select'
import {TemplateFeaturesComponent} from './template-features/template-features.component'
import {
  DamItemTemplateFeaturesService
} from '../../../../compob2b-admin/src/app/cabinet/dam/files/create-update/dam-item-template-features.service'
import {
  TemplateFeatureService
} from '../../../../compob2b-admin/src/app/cabinet/pim/product/create-update/features/template-feature.service'

@NgModule({
  declarations: [
    TfSelectComponent,
    TfBooleanComponent,
    TfRangeComponent,
    TfIntervalComponent,
    TfStringComponent,
    TfHtmlComponent,
    TfSizeComponent,
    TfLinkComponent,
    TfSmartlistComponent,
    TemplateFeaturesComponent,
  ],
  exports: [
    TfSelectComponent,
    TfBooleanComponent,
    TfRangeComponent,
    TfIntervalComponent,
    TfStringComponent,
    TfHtmlComponent,
    TfSizeComponent,
    TfLinkComponent,
    TfSmartlistComponent,
    TemplateFeaturesComponent,
  ],
  imports: [
    AdminSharedModule,
    NbIconModule,
    NbTooltipModule,
    RouterLink,
    ReactiveFormsModule,
    NgIf,
    TuiEditor,
    NbInputModule,
    NgClass,
    NgSelectComponent,
    AsyncPipe,
    NgMultiLabelTemplateDirective,
    NgForOf,
    SlicePipe,
    NbButtonModule,
    NbAccordionModule,
    NbSpinnerModule,
    DatePipe,
    NbFormFieldModule,
    FormsModule
  ]
})
export class FeaturesModule {

  public static forDam(): ModuleWithProviders<FeaturesModule> {
    return {
      ngModule: FeaturesModule,
      providers: [
        {provide: TemplateFeatureService, useClass: DamItemTemplateFeaturesService},
        {provide: 'templateFeatureService', useClass: DamItemTemplateFeaturesService},
      ]
    };
  }

  public static forPim(): ModuleWithProviders<FeaturesModule> {
    return {
      ngModule: FeaturesModule,
      providers: [
        {provide: TemplateFeatureService, useClass: TemplateFeatureService},
        {provide: 'templateFeatureService', useClass: TemplateFeatureService},
      ]
    };
  }

}
